import { gql } from '@apollo/client';

const getCluster = (clusterUri: string) => {
    return {
        variables: {
            clusterUri,
        },
        query: gql`
            query GetRedshiftCluster($clusterUri: String!) {
                getRedshiftCluster(clusterUri: $clusterUri) {
                    label
                    owner
                    created
                    description
                    SamlGroupName
                    userRoleForCluster
                    authorized_resources
                    vpc
                    stack {
                        status
                        region
                    }
                    organization {
                        label
                        organizationUri
                    }
                    environment {
                        label
                        environmentUri
                    }
                }
            }
        `,
    };
};

export default getCluster;
